var keywordsToKind = {
    mod: "mod keyword",
    div: "div keyword",
    to: "to keyword",
    in: "in keyword",
    and: "and keyword",
    or: "or keyword",
};
function addSanityCheckToScanFunc(originalString, originalScan) {
    var constructedString = "";
    return function () {
        var token = originalScan();
        if (token.end - token.start <= 0 && token.kind !== "end token") {
            throw new Error("Scanner fail: end=" + token.end + " start=" + token.start + " str='" + originalString + "'");
        }
        if (originalString.slice(token.start, token.end) !== token.text) {
            throw new Error("Scanner fail: token slice differs");
        }
        if (token.kind !== "end token") {
            constructedString += token.text;
        }
        else {
            if (constructedString !== originalString) {
                throw new Error("Scanner fail: constructed string differs!");
            }
        }
        return token;
    };
}
export function createScanner(str) {
    var pos = 0;
    var end = str.length;
    function isWhitespace(char) {
        return char === " " || char === "\n" || char === "\r" || char === "\t";
    }
    function scanWhitespace() {
        var start = pos;
        while (pos < end && isWhitespace(str[pos])) {
            pos++;
        }
        var token = {
            kind: "white space token",
            start: start,
            end: pos,
            text: str.slice(start, pos),
        };
        return token;
    }
    function isDigit(char) {
        return char.length === 1 && "0123456789".indexOf(char) > -1;
    }
    function oneCharTokenToKind(char) {
        return char === "("
            ? "open brace token"
            : char === ")"
                ? "close brace token"
                : char === "["
                    ? "open paren token"
                    : char === "]"
                        ? "close paren token"
                        : char === "/"
                            ? "slash token"
                            : char === "*"
                                ? "asterisk token"
                                : char === "+"
                                    ? "plus token"
                                    : char === "-"
                                        ? "minus token"
                                        : char === "="
                                            ? "equals token"
                                            : char === ";"
                                                ? "semicolon token"
                                                : undefined;
    }
    function lookAhead(charCount) {
        if (charCount === void 0) { charCount = 1; }
        return pos + charCount < end ? str[pos + charCount] : undefined;
    }
    function scanIdentifierOrKeyword() {
        var start = pos;
        var text = "";
        var keywordKind = undefined;
        while (pos < end &&
            "qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM01234567890_".indexOf(str[pos]) > -1) {
            pos++;
            text = str.slice(start, pos);
            keywordKind =
                text in keywordsToKind ? keywordsToKind[text] : undefined;
            if (keywordKind) {
                // Some quests have "[p1] mod1000" (without spaces)
                break;
            }
        }
        var kind = keywordKind !== undefined ? keywordKind : "identifier";
        if (start === pos) {
            throw new Error("Unknown char " + str[pos]);
        }
        return {
            kind: kind,
            start: start,
            end: pos,
            text: text,
        };
    }
    function scanNumber() {
        var dotSeen = false;
        var start = pos;
        var trailingSpacesStartsAtPos = undefined;
        while (pos < end) {
            var thisCharacterIsASpace = false;
            var char = str[pos];
            if (isDigit(char)) {
                // ok
            }
            else if (char === "." || char === ",") {
                if (dotSeen) {
                    break;
                }
                var nextNextChar = lookAhead();
                if (nextNextChar !== "." && nextNextChar !== ",") {
                    dotSeen = true;
                }
                else {
                    break;
                }
                // } else if (char === "-" && pos === start) {
                // Ok here
            }
            else if (char === " ") {
                thisCharacterIsASpace = true;
            }
            else {
                break;
            }
            // Allow spaces inside digits but keep spaces as separate token if they are trailing spaces
            if (thisCharacterIsASpace) {
                if (trailingSpacesStartsAtPos === undefined) {
                    // Ok, looks like a series of spaces have been begun
                    trailingSpacesStartsAtPos = pos;
                }
                else {
                    // Series of spaces is still continues
                }
            }
            else {
                // Character is not a space and belongs to digit chars set.
                // So, spaces are not a trailing spaces
                trailingSpacesStartsAtPos = undefined;
            }
            pos++;
        }
        if (trailingSpacesStartsAtPos !== undefined) {
            // health check
            if (!str.slice(trailingSpacesStartsAtPos, pos).match(/^\s*$/)) {
                throw new Error("Unknown internal state: trailingSpacesStartsAtPos is set but tail is not spaces");
            }
            pos = trailingSpacesStartsAtPos;
        }
        var token = {
            kind: "numeric literal",
            start: start,
            end: pos,
            text: str.slice(start, pos),
        };
        return token;
    }
    function scan() {
        if (pos >= end) {
            return {
                kind: "end token",
                start: pos,
                end: pos,
                text: "",
            };
        }
        var char = str[pos];
        if (isWhitespace(char)) {
            return scanWhitespace();
        }
        var lookAheadChar = lookAhead();
        if (char === "." && lookAheadChar === ".") {
            var token = {
                kind: "dotdot token",
                start: pos,
                end: pos + 2,
                text: char + lookAheadChar,
            };
            pos += 2;
            return token;
        }
        if (char === "<" && lookAheadChar === ">") {
            var token = {
                kind: "not equals token",
                start: pos,
                end: pos + 2,
                text: char + lookAheadChar,
            };
            pos += 2;
            return token;
        }
        if (char === ">" && lookAheadChar === "=") {
            var token = {
                kind: "greater than eq token",
                start: pos,
                end: pos + 2,
                text: char + lookAheadChar,
            };
            pos += 2;
            return token;
        }
        if (char === "<" && lookAheadChar === "=") {
            var token = {
                kind: "less than eq token",
                start: pos,
                end: pos + 2,
                text: char + lookAheadChar,
            };
            pos += 2;
            return token;
        }
        if (char === ">" && lookAheadChar !== "=") {
            var token = {
                kind: "greater than token",
                start: pos,
                end: pos + 1,
                text: char,
            };
            pos++;
            return token;
        }
        if (char === "<" && lookAheadChar !== "=") {
            var token = {
                kind: "less than token",
                start: pos,
                end: pos + 1,
                text: char,
            };
            pos++;
            return token;
        }
        if (isDigit(char)
        // || (char === "-" && lookAheadChar && isDigit(lookAheadChar))
        ) {
            return scanNumber();
        }
        var oneCharKind = oneCharTokenToKind(char);
        if (oneCharKind !== undefined) {
            var token = {
                kind: oneCharKind,
                start: pos,
                end: pos + 1,
                text: char,
            };
            pos++;
            return token;
        }
        return scanIdentifierOrKeyword();
    }
    return addSanityCheckToScanFunc(str, scan);
}
//# sourceMappingURL=data:application/json;base64,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